import { useState } from "react";
import { X } from "lucide-react";

export default function FloatingWhatsApp() {
  const [isOpen, setIsOpen] = useState(false);

  const [formData, setFormData] = useState({
    nama: "",
    email: "",
    pesan: "",
  });

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = () => {
    const phoneNumber = "628139789814";

    const message = `
Nama: ${formData.nama}
Email: ${formData.email}
Pesan: ${formData.pesan}
    `;

    const encodedMessage = encodeURIComponent(message);

    window.open(
      `https://wa.me/${phoneNumber}?text=${encodedMessage}`,
      "_blank"
    );
  };

  return (
    <>
      {/* FLOATING BUTTON */}
      <div className="fixed bottom-20 right-5 z-10">
        <button
          onClick={() => setIsOpen(true)}
          className="bg-green-500 hover:bg-green-600 w-16 h-16 rounded-full flex items-center justify-center shadow-lg transition"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="w-8 h-8 text-white"
            fill="currentColor"
            viewBox="0 0 24 24"
          >
            <path d="M20.52 3.48A11.92 11.92 0 0012.05 0C5.5 0 .15 5.35.15 11.9c0 2.1.55 4.15 1.6 5.96L0 24l6.29-1.64a11.9 11.9 0 005.76 1.47h.01c6.55 0 11.9-5.35 11.9-11.9 0-3.17-1.23-6.15-3.44-8.45z" />
          </svg>
        </button>
      </div>

      {/* POPUP */}
      {isOpen && (
        <div className="fixed bottom-24 right-6 w-80 bg-[#f3ecd9] rounded-xl shadow-2xl z-50 overflow-hidden animate-fadeIn">
          
          {/* HEADER */}
          <div className="bg-primary text-white p-4 flex justify-between items-center">
            <div>
              <h3 className="font-semibold">Admin Talentlink</h3>
              <p className="text-sm">Monday - Friday</p>
              <p className="text-sm">Working Hour 09.00 - 17.00</p>
            </div>
            <button onClick={() => setIsOpen(false)}>
              <X />
            </button>
          </div>

          {/* FORM */}
          <div className="p-4 space-y-3">
            <input name="nama" onChange={handleChange} placeholder="Nama *" className="input-wa" />
            <input name="email" onChange={handleChange} placeholder="Email *" className="input-wa" />
            <textarea name="pesan" onChange={handleChange} placeholder="Pesan *" className="input-wa h-20 resize-none" />

            <button
              onClick={handleSubmit}
              className="w-full bg-primary text-white py-2 rounded-lg hover:bg-green-500 transition"
            >
              Kirim ke WhatsApp
            </button>
          </div>
        </div>
      )}
    </>
  );
}
